import React, { useEffect, useState } from "react";
import { numDifferentiation } from "../../utils";
export default function TermSendMessage({ setMessage, message, sendAfterEnter, send, uploadFile, lastMessage, agentName }) {
  const [disableInput, setDisableInput] = useState(false)
  const [monthlyExpense, isMonthlyExpense] = useState(false)
  const [loanInput, isLoneInput] = useState(false)
  const [error, setError] = useState(null)
  useEffect(() => {
    if (lastMessage && lastMessage.type === 'text') {
      setDisableInput(false)
      if (lastMessage.content === "Please enter your monthly expenses") {
        isMonthlyExpense(true)
      }
      else {
        isLoneInput(true)
      }
    }
    else {
      setDisableInput(true)
    }
  }, [lastMessage])
  const validateMobile = (e) => {
    e.target.value = (e.target.value).replace(/\D/g, '')
    setMessage(e.target.value);

  }

  const handleKeyDown=(e)=>{
    setError(null)
    
    if (e.key == 'Enter') {
      // sendAfterEnter(e)
    let value = Number(message)
    if (monthlyExpense) {
      if (10000 <= value && value <= 500000) {
        setError(null)
        sendAfterEnter(e);
      }
      else {
        setError("Monthly expenses should be between Rs 10,000 and 5,00,000")
      }
    }
    if (loanInput) {
      if (100000 <= value && value <= 100000000) {
        setError(null)
        sendAfterEnter(e);
      }
      else {
        setError("Loan amount should be between Rs 1,00,000 and Rs 1,00,00,000")
      }
    }
  }
  }
  const sendMsg=(e)=>{
    // send()
    setError(null)
    let value = Number(message)
    if (value === 0) {
      return null;
    }
    if (monthlyExpense) {
      if (10000 <= value && value<= 500000) {
        send();
      }
      else {
        setError("Monthly expenses should be between Rs 10,000 and 5,00,000")
      }
    }
    if (loanInput) {
      if (100000 <= value && value<= 100000000) {
        send();
      }
      else {
        setError("Loan amount should be between Rs 1,00,000 and Rs 10,00,00,000")
      }
    }
  }
  return (
    <>
      
      <div className="num-string"> {message && !error ? numDifferentiation(Number(message)) : error ? <div style={{ color: "red" }}>{error ? error : null}</div> : null}</div>
      
      <textarea
        value={message}
        style={{ flex: 1 }}
        maxLength={10}
        // placeholder={disableInput ? "Please select an option... " : "Send a message..."}
        placeholder={"Type your query..."}
        label=""
        disabled={disableInput}
        required
        onChange={(event) => validateMobile(event)}
        onKeyDown={(e) => handleKeyDown(e)}
      />
      {/* <label className="fileInput">
        <input type={'file'} onChange={(event) => uploadFile(event.target.files)}></input>
      </label> */}
      <button className="SendMsgbutton disable" onClick={sendMsg}>Send</button>
    </>
  );
}
